// extracted by mini-css-extract-plugin
export default {"video":"FarmFresh_video__nKAn5","twoCol":"FarmFresh_twoCol__s5iF7"};